module.exports = __webpack_public_path__ + "img/SPIMFURNISHING.baf99686.svg";